module.exports = __webpack_public_path__ + "static/media/fullscreen_logo_blue.0b205670.svg";